import { createApi } from "@reduxjs/toolkit/query/react";

import type { UserDTO } from "../../../../common/types/UserDTO";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export const userService = createApi({
  reducerPath: "userService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  tagTypes: ["User"],
  endpoints: (builder) => ({
    getUser: builder.query<UserDTO, { id: number }>({
      query: ({ id }) => `api/identity/users/${id}`,
      providesTags: (user) => [{ type: "User", id: user?.id }],
    }),
  }),
});

export const { useGetUserQuery } = userService;
